import axios from 'axios'
import { camelizeKeys } from 'humps'
import { getCsrfToken } from './utils'

const apiClient = axios.create({
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

apiClient.interceptors.request.use((config) => {
  config.headers['X-CSRF-Token'] = getCsrfToken()
  return config
})

apiClient.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'object') {
      response.data = camelizeKeys(response.data)
    }
    return response
  },
  (error) => {
    if (error.response?.data && typeof error.response.data === 'object') {
      error.response.data = camelizeKeys(error.response.data)
    }
    return Promise.reject(error)
  },
)

export default apiClient
